import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { TransactionSerie } from '../_types/transaction-serie';
import { TransactionType } from '../../transactions/_types/transaction-type';
import { TransactionsSeriesService } from '../_services/transactions-series.service';
import { TransactionsTypesService } from '../../transactions/_services/transactions-types.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-transactions-series-detail',
    templateUrl: './transactions-series-detail.component.html',
    styleUrls: ['./transactions-series-detail.component.scss'],
    standalone: false
})
export class TransactionsSeriesDetailComponent implements OnInit {
  public transactionSerieFormGroup!: RxFormGroup;

  public transactionSerie: TransactionSerie = new TransactionSerie();
  public transactionsTypes: TransactionType[] = [];

  public loading: boolean = false;
  public totalRecords: number = 0;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private transactionsSeriesService: TransactionsSeriesService,
    private transactionsTypesService: TransactionsTypesService,
    private topbarService: TopbarService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {
    this.transactionSerieFormGroup = this.formBuilder.formGroup<TransactionSerie>(this.transactionSerie) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de serie de transacción");
    this.topbarService.addBreadcrumb("Series de transacción", "/transactionsSeries");
    this.loadTransactionsTypes();

    let id = this.route.snapshot.params['guid'];
    if (id != null && id != '0') {
      await this.loadTransactionSerie(id);
    }
    this.allowWrite = this.loginService.hasPermission("TRANSACTION_SERIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("TRANSACTION_SERIES.DELETE");
  }

  async loadTransactionSerie(id: string) {
    this.transactionSerie = await firstValueFrom(this.transactionsSeriesService.get(id));
    this.transactionSerieFormGroup.patchValue(this.transactionSerie);
  }

  async loadTransactionsTypes() {
    let response = await firstValueFrom(this.transactionsTypesService.all());
    this.transactionsTypes = response.data;
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.transactionSerieFormGroup);
    if (valid) {
      this.transactionSerie = Object.assign(this.transactionSerie, this.transactionSerieFormGroup.value);

      let transactionSerieItem = await firstValueFrom(this.transactionsSeriesService.save(this.transactionSerie));
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Serie de transacción guardada correctamente." });
      this.router.navigate(['transactionsSeries']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la serie de transacción?",
      header: "Eliminar serie de transacción",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.transactionsSeriesService.delete(this.transactionSerie.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Serie de transacción eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  cancel() {
    this.router.navigate(['transactionsSeries']);
  }
}
